import React from 'react';

import { AuthProvider } from './auth';
import { SidebarDrawerProvider } from './sidebarDrawer';

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <SidebarDrawerProvider>{children}</SidebarDrawerProvider>
  </AuthProvider>
);

export default AppProvider;
